import React from "react";
import styled from "styled-components";
import { mediaPhone } from "@/shared/theme/breakpoints";

interface ResponsiveLabelProps {
	/** Shown above the phone breakpoint. */
	full: React.ReactNode;
	/** Shown at phone widths and below. */
	short: React.ReactNode;
}

const Full = styled.span`
	${mediaPhone`
		display: none;
	`}
`;

const Short = styled.span`
	display: none;

	${mediaPhone`
		display: inline;
	`}
`;

/**
 * Text with a shorter phone version, picked by CSS so no JS or layout branching is needed. Both are
 * rendered; the hidden one is display: none, so assistive tech only reads the visible text.
 */
export const ResponsiveLabel: React.FC<ResponsiveLabelProps> = ({ full, short }) => (
	<>
		<Full>{full}</Full>
		<Short>{short}</Short>
	</>
);
